import { useMutation } from 'react-query'
import { api } from '../api'
import { ApiUrlEnum } from '../../enums/ApiUrlEnum'

export const useResetPasswordMutation = () => {
  return useMutation({
    mutationFn: (data: { email?: string }) => api.post(ApiUrlEnum.USER_RESET_PASSWORD, data),
  })
}
